export const metastasisId = '0f30d7fd-047e-47c8-8cad-a0909271caf1';